// react-query `meta` flags. Deliberately a dependency-free leaf module so
// component call sites can import the constant without pulling in the query
// client (and with it i18n, sonner and Sentry).

/**
 * Opt a mutation out of the global error toast installed by
 * `createQueryClient()` (see src/lib/query-client.ts).
 *
 * Only for the case that handler cannot detect: the call site awaits
 * `mutateAsync()` inside its own `try/catch` and already renders something
 * user-facing there (an upgrade dialog, an `alert`, an error state). Mutations
 * that pass an `onError` option are skipped automatically and do not need it.
 *
 * Do NOT add this to silence a mutation whose failure the user currently never
 * learns about — that silence is precisely the bug (B-new-85).
 */
export const SKIP_GLOBAL_ERROR_TOAST = 'skipGlobalErrorToast'
